(() => {
  if (window.mcEditorial) { window.mcEditorial.init(document); return; }
  const init = (scope) => {
    scope.querySelectorAll('[data-mc-brands]:not([data-mc-ready])').forEach(root => {
      root.dataset.mcReady = 'true';
      const input = root.querySelector('[data-mc-brand-filter]');
      const entries = [...root.querySelectorAll('[data-mc-brand]')];
      const update = () => {
        const query = input.value.trim().toLocaleLowerCase();
        let count = 0;
        entries.forEach(item => { item.hidden = !item.dataset.mcBrand.toLocaleLowerCase().includes(query); if (!item.hidden) count++; });
        root.querySelector('[data-mc-brand-count]').textContent = `${count} ${count === 1 ? 'brand' : 'brands'}`;
        root.querySelector('[data-mc-brand-empty]').hidden = count !== 0;
      };
      input.addEventListener('input', update); update();
    });
    scope.querySelectorAll('[data-mc-countdown]:not([data-mc-ready])').forEach(root => {
      root.dataset.mcReady = 'true';
      // Explicit timezone required: do not reinterpret a merchant's local date.
      const dateText = root.dataset.mcCountdown;
      const validFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(dateText);
      const [year, month, day] = dateText.slice(0, 10).split('-').map(Number);
      const validDate = month >= 1 && month <= 12 && day >= 1 && day <= new Date(Date.UTC(year, month, 0)).getUTCDate();
      const deadline = validFormat && validDate ? Date.parse(dateText) : NaN;
      const time = root.querySelector('[data-mc-time]');
      if (!Number.isFinite(deadline) || !time) {
        if (root.dataset.mcEditor === 'true') {
          root.hidden = false;
          root.textContent = 'Enter a valid end time with a timezone, such as 2026-11-30T23:59:00+11:00.';
        }
        return;
      }
      root.hidden = false;
      root.querySelector('time').textContent = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Sydney', dateStyle: 'medium', timeStyle: 'short'
      }).format(deadline) + ' (Sydney time)';
      let timer;
      const update = () => {
        if (!root.isConnected) { clearInterval(timer); return; }
        const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        time.textContent = seconds ? `${Math.floor(seconds/86400)}d ${Math.floor(seconds/3600)%24}h ${Math.floor(seconds/60)%60}m ${seconds%60}s remaining` : 'This promotion has ended';
        if (!seconds) {
          root.dataset.mcEnded = 'true';
          if (root.dataset.mcHideEnded === 'true') root.closest('[data-mc-promo-banner]')?.querySelector('[data-mc-promo-cta]')?.setAttribute('hidden', '');
          clearInterval(timer);
        }
      };
      update(); if (deadline > Date.now()) timer = setInterval(update, 1000);
    });
    scope.querySelectorAll('[data-mc-header]:not([data-mc-ready])').forEach(header => {
      header.dataset.mcReady = 'true';
      const searchToggle = header.querySelector('[data-mc-search-toggle]');
      const closeMobileSearch = () => {
        delete header.dataset.mcSearchOpen;
        searchToggle?.setAttribute('aria-expanded', 'false');
        searchToggle?.setAttribute('aria-label', 'Open search');
      };
      searchToggle?.addEventListener('click', () => {
        const open = header.dataset.mcSearchOpen !== 'true';
        if (open) {
          header.dataset.mcSearchOpen = 'true';
          searchToggle.setAttribute('aria-expanded', 'true');
          searchToggle.setAttribute('aria-label', 'Close search');
          header.querySelector('[data-selector="search-input-mobile"]')?.focus();
        } else {
          document.querySelector('predictive-search [data-selector="close-search"]')?.click();
          closeMobileSearch();
        }
      });
      document.addEventListener('click', event => {
        if (event.target.closest('[data-selector="close-search"], [data-selector="predictive-search-overlay"]')) closeMobileSearch();
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && header.dataset.mcSearchOpen === 'true') {
          closeMobileSearch();
          searchToggle?.focus();
        }
      });
      // Menu geometry, dismissal and mobile focus are owned by mc-navigation.js.

    });

  };
  // Keep Gorgias availability and holiday rules in the helpdesk. Only the
  // draft's greeting and hours copy are customized here.
  const initChatWording = () => {
    const greeting = document.querySelector('[data-mc-chat-message]')?.dataset.mcChatMessage;
    if (!greeting || !window.GorgiasChat) return;
    window.GorgiasChat.init().then(() => {
      window.GorgiasChat.updateTexts({
        contactFormEndingMessage: 'Thanks for your message. We’ll get back to you when we’re next online. Our live hours are Monday to Friday, 9am–5pm (Sydney time), excluding public holidays.'
      });
      let greetingTimer;
      const addHours = (attempt = 0) => {
        clearTimeout(greetingTimer);
        if (!window.GorgiasChat.isOpen()) return;
        const chatDocument = document.getElementById('chat-window')?.contentDocument;
        const heading = chatDocument?.getElementById('homepage-header');
        if (heading) {
          if (!heading.querySelector('[data-mc-chat-hours]')) {
            const note = chatDocument.createElement('p');
            note.dataset.mcChatHours = 'true';
            note.textContent = greeting;
            note.style.cssText = 'font-family:inherit;font-size:13px;font-weight:400;line-height:1.5;color:#fff;max-width:320px;margin:14px auto 0;padding:0 12px;text-align:center;';
            heading.appendChild(note);
          }
        } else if (attempt < 20) greetingTimer = setTimeout(() => addHours(attempt + 1), 100);
      };
      window.GorgiasChat.on('widget:opened', () => { greetingTimer = setTimeout(() => addHours(), 100); });
      window.GorgiasChat.on('widget:closed', () => clearTimeout(greetingTimer));
      addHours();
    }).catch(error => console.warn('Musos chat wording could not be applied.', error));
  };
  if (window.GorgiasChat) initChatWording();
  else window.addEventListener('gorgias-widget-loaded', initChatWording, {once: true});
  window.mcEditorial = {init};
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
